import config from "@/config"
import {i18n} from "@/locales";
import * as _ from "lodash-es";
import http from "@/utils/request"
import {UUIDV5 as UUID} from "@/utils/uuid";
import safeGet from "@fengqiaogang/safe-get";

export const dictCache = new Map();

const updateBugTypeNames = function (node) {
  // 计算当前节点的 bugTypeName
  node.bugTypeName = node.bugTypeName || i18n(node.code);
  // 递归处理子节点
  if (node.children && node.children.length > 0) {
    node.children = _.map(node.children, updateBugTypeNames);
  }
  return node;
}

const toField = function (value) {
  const configId = safeGet(value, "id");                           // 唯一值
  const dictLabel = safeGet(value, 'showName');                    // 名称
  // const disabled = Number(safeGet(value, 'filedKey') || 0) === 1;  // 是否允许删除
  return {...value, configId, dictLabel};
}

export default {
  menu: {
    myMenus: {
      url: `${config.API_URL}/lqa-game/system/menu/getRoutersMenu`,
      name: "获取我的菜单",
      get: function (config = {}) {
        return http.get(this.url, {}, config);
      }
    },
    getMenus: {
      url: `${config.API_URL}/lqa-game/system/menu/getMyRoutersMenu?roleName=`,
      name: "获取我的菜单",
      get: function (params) {
        return http.get(this.url + params);
      }
    },
    list: {
      url: `${config.API_URL}/lqa-game/system/menu/game/treeselect`,
      name: "获取菜单",
      get: function (appName) {
        return http.get(this.url, {app: appName});
      }
    },
    rolelist: {
      url: `${config.API_URL}/lqa-game/system/menu/getMenuByRoleId`,
      name: "获取角色菜单",
      get: function (roleId, appName) {
        return http.get(this.url, {roleId, app: appName});
      }
    },
  },

  account: {
    changePwd: {
      url: `${config.API_URL}/lqa-game/system/account/changePwd`,
      name: "新增字典类型",
      post: function (data) {
        return http.post(this.url, data);
      }
    },
    unLockUser: {
      url: `${config.API_URL}/lqa-game/system/account/unlockUser?ipAddress=`,
      name: "解锁",
      get: function (param) {
        return http.get(this.url + param);
      }
    },
  },
  bugType: {
    create: {
      url: `${config.API_URL}/lqa-game/system/bugType`,
      name: "添加字典数据",
      post: function (projectNum, text, parentId) {
        // Bug 分类
        const data = {projectNum, bugTypeParent: parentId, bugTypeName: text};
        return http.post(this.url, data);
      }
    },
    remove: {
      url: `${config.API_URL}/lqa-game/system/bugType`,
      name: "删除字典数据",
      put: function (id) {
        if (id || id === 0) {
          const url = `${this.url}/${id}`;
          return http.delete(url);
        }
        return void 0;
      }
    },
    set: {
      url: `${config.API_URL}/lqa-game/system/bugType`,
      name: "修改字典数据",
      put: function (id, value) {
        const data = {id, bugTypeName: value};
        return http.put(this.url, data);
      }
    },
    sort: {
      url: `${config.API_URL}/lqa-game/system/bugType/sortBugType`,
      name: "字典数据排序",
      post: function (list) {
        return http.post(this.url, list);
      },
    },
    tree: {
      url: `${config.API_URL}/lqa-game/system/bugType/bugtree`,
      name: "获取字典类型树",
      get: async function (projectNum) {
        const query = {};
        if (projectNum) {
          Object.assign(query, {projectNum});
        }
        const res = await http.get(this.url, query);
        if (res && res.code === 200) {
          const data = _.map(res.data, updateBugTypeNames);
          return {code: 200, data};
        }
        return {
          code: 200,
          data: []
        };
      }
    },
    list: {
      url: `${config.API_URL}/lqa-game/system/bugType/list`,
      name: "获取字典类型树",
      get: function () {
        return http.get(this.url);
      }
    }
  },
  field: {
    create: {
      url: `${config.API_URL}/lqa-game/system/bugFiledConfig`,
      name: "添加自定义字段",
      post: async function (projectNum, text) {
        const data = typeof text === "string" ? {projectNum, showName: text} : {...text, projectNum};
        const res = await http.post(this.url, data);
        if (res && res.code === 200) {
          return {...res, data: toField(res.data || {})};
        }
        return res;
      }
    },
    remove: {
      url: `${config.API_URL}/lqa-game/system/bugFiledConfig`,
      name: "删除自定义字段",
      put: function (id) {
        if (id || id === 0) {
          const url = `${this.url}/${id}`;
          return http.delete(url);
        }
        return void 0;
      }
    },
    set: {
      url: `${config.API_URL}/lqa-game/system/bugFiledConfig`,
      name: "修改自定义字段数据",
      put: async function (id, value) {
        const data = typeof value === "string" ? {id, showName: value} : {id, ...value};
        return http.put(this.url, data);
      }
    },
    sort: {
      url: `${config.API_URL}/lqa-game/system/bugFiledConfig/sortField`,
      name: "自定义字段数据排序",
      post: function (list) {
        const value = _.map(list, function (item) {
          const showName = safeGet(item, "dictLabel");
          return {..._.omit(item, ["dictLabel", "disabled", "configId"]), showName};
        })
        return http.post(this.url, value);
      },
    },
    list: {
      url: `${config.API_URL}/lqa-game/system/bugFiledConfig/getDefault`,
      name: "获取自定义字段数据列表",
      get: async function (projectNum) {
        const query = {projectNum};
        const res = await http.get(this.url, query);
        if (res && res.code === 200) {
          const list = safeGet(res, 'data') || [];
          return {...res, data: _.map(list, toField)};
        }
        return res;
      }
    },
    detail: {
      url: `${config.API_URL}/lqa-game/system/bugFiledConfig/getBugFiled`,
      name: "获取自定义字段数据列表",
      get: async function (projectNum, params = {}) {
        const query = {projectNum, ...params};
        const res = await http.get(this.url, query);
        if (res && res.code === 200) {
          const list = safeGet(res, 'data') || [];
          return {...res, data: _.map(list, toField)};
        }
        return res;
      }
    }
  },
  dic: {
    tree: {
      url: `${config.API_URL}/lqa-game/system/dict/type/optionselect`,
      name: "获取字典树",
      get: function () {
        return http.get(this.url);
      }
    },
    list: {
      url: `${config.API_URL}/lqa-game/system/dict/data/list`,
      name: "字典明细",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    create: {
      url: `${config.API_URL}/lqa-game/system/bugConfig`,
      name: "添加字典数据",
      post: function (type, projectNum, text) {
        const data = {projectNum, dictType: type, dictLabel: text};
        return http.post(this.url, data);
      }
    },
    remove: {
      url: `${config.API_URL}/lqa-game/system/bugConfig`,
      name: "删除字典数据",
      put: function (id) {
        if (id || id === 0) {
          const url = `${this.url}/${id}`;
          return http.delete(url);
        }
        return void 0;
      }
    },
    set: {
      url: `${config.API_URL}/lqa-game/system/bugConfig`,
      name: "修改字典数据",
      put: function (id, value) {
        const data = {configId: id, dictLabel: value};
        return http.put(this.url, data);
      }
    },
    get: {
      url: `${config.API_URL}/lqa-game/system/dict/data/type/`,
      name: "获取字典数据",
      /**
       * @param name       字典名称
       * @param projectNum 项目编号
       * @param cache      是否使用缓存功能
       */
      get: async function (name, projectNum, cache) {
        let query = {};
        let key;
        const url = `${this.url}${name}`;
        if (projectNum) {
          query = {projectNum};
        }
        if (cache) {
          key = UUID({url, query});
          if (dictCache.has(key)) {
            return dictCache.get(key);
          }
        }
        const res = await http.get(url, query);
        if (cache && key) {
          dictCache.set(key, res);
        }
        return res;
      },
    },
    sort: {
      url: `${config.API_URL}/lqa-game/system/bugConfig/updateConfig`,
      name: "字典数据排序",
      post: function (list, projectNum) {
        const sysDictData = _.map(list, function (item, index) {
          return {...item, dictSort: index + 1}
        });
        const data = {projectNum, sysDictData};
        return http.post(this.url, data);
      },
    },
    type_post: {
      url: `${config.API_URL}/lqa-game/system/dict/type`,
      name: "新增字典类型",
      post: function (params) {
        return http.post(this.url, params);
      }
    },
    type_update: {
      url: `${config.API_URL}/lqa-game/system/dict/type`,
      name: "新增字典类型",
      put: function (params) {
        return http.put(this.url, params);
      }
    },
    type_del: {
      url: `${config.API_URL}/lqa-game/system/dict/type/`,
      name: "新增字典类型",
      delete: function (params) {
        return http.delete(this.url + params);
      }
    },
    data_post: {
      url: `${config.API_URL}/lqa-game/system/dict/data`,
      name: "新增字典类型",
      post: function (params) {
        return http.post(this.url, params);
      }
    },
    data_del: {
      url: `${config.API_URL}/lqa-game/system/dict/data/`,
      name: "新增字典类型",
      delete: function (params) {
        return http.delete(this.url + params);
      }
    },
    update: {
      url: `${config.API_URL}/lqa-game/system/dict/data`,
      name: "更新字典数据",
      put: function (params) {
        return http.put(this.url, params);
      }
    },
    refreshDicCache: {
      url: `${config.API_URL}/lqa-game/system/dict/data/refreshCache`,
      name: "刷新字典数据",
      get: function () {
        return http.get(this.url);
      }
    },
  },
  role: {
    list: {
      url: `${config.API_URL}/lqa-game/system/role/list`,
      name: "获取角色列表",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    updateRole: {
      url: `${config.API_URL}/lqa-game/system/role`,
      name: "获取角色列表",
      put: function (data, appName) {
        return http.put(this.url, data, {
          params: {
            app: appName
          }
        });
      }
    },
    newRole: {
      url: `${config.API_URL}/lqa-game/system/role`,
      name: "获取角色列表",
      post: function (data, appName) {
        return http.post(this.url, data, {
          params: {
            app: appName
          }
        });
      }
    },
    delRole: {
      url: `${config.API_URL}/lqa-game/system/role/`,
      name: "获取角色列表",
      delete: function (param, appName) {
        return http.delete(this.url + param, void 0, {
          params: {
            app: appName
          }
        });
      }
    },
    getRoleMenus: {
      url: `${config.API_URL}/lqa-game/system/rolemenu/getRoleMenuLs`,
      name: "获取角色菜单ID列表",
      get: function (roleId, appName) {
        return http.get(this.url, {roleId, app: appName});
      }
    },
    getAllRoleDict: {
      url: `${config.API_URL}/lqa-game/system/role/allRoleDict`,
      name: "获取角色字典",
      get: function (appName = "") {
        return http.get(this.url, {app: appName});
      }
    },
    updateRoleMenu: {
      url: `${config.API_URL}/lqa-game/system/rolemenu/resetrolemenu`,
      name: "获取角色菜单信息",
      post: function (data, appName) {
        return http.post(this.url, data, {
          params: {
            app: appName
          }
        });
      }
    },

  },
  config: {
    list: {
      url: `${config.API_URL}/lqa-game/system/config/allList`,
      name: "获取角色列表",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
  },
  company: {
    list: {
      url: `${config.API_URL}/lqa-game/game/org/company/page`,
      name: "获取角色列表",
      post: function (params) {
        return http.post(this.url, params);
      }
    },
    updateCom: {
      url: `${config.API_URL}/lqa-game/system/company`,
      name: "获取角色列表",
      put: function (data) {
        return http.put(this.url, data);
      }
    },
    newCom: {
      url: `${config.API_URL}/lqa-game/system/company`,
      name: "获取角色列表",
      post: function (data) {
        return http.post(this.url, data);
      }
    },
    delCom: {
      url: `${config.API_URL}/lqa-game/system/company/`,
      name: "获取角色列表",
      delete: function (param) {
        return http.delete(this.url + param);
      }
    },
    listPage: {
      url: `${config.API_URL}/lqa-game/system/company/list`,
      name: "获取角色列表",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    treeList: {
      url: `${config.API_URL}/lqa-game/system/company/tree`,
      name: "获取角色列表",
      get: function () {
        return http.get(this.url);
      }
    },
  },
  dept: {
    list: {
      url: `${config.API_URL}/lqa-game/game/common/group-tree?key=`,
      name: "获取部门列表",
      post: function (params) {
        return http.post(this.url + params);
      }
    },
    all_list: {
      url: `${config.API_URL}/lqa-game/system/dept/getOrgTree`,
      name: "获取所有部门列表",
      get: function () {
        return http.get(this.url);
      }
    },
    deptList: {
      url: `${config.API_URL}/lqa-game/system/dept/list`,
      name: "获取部门列表",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    updateDept: {
      url: `${config.API_URL}/lqa-game/system/dept`,
      name: "获取角色列表",
      put: function (data) {
        return http.put(this.url, data);
      }
    },
    newDept: {
      url: `${config.API_URL}/lqa-game/system/dept`,
      name: "获取角色列表",
      post: function (data) {
        return http.post(this.url, data);
      }
    },
    delDept: {
      url: `${config.API_URL}/lqa-game/system/dept/`,
      name: "获取角色列表",
      delete: function (param) {
        return http.delete(this.url + param);
      }
    },

  },
  user: {
    list: {
      url: `${config.API_URL}/lqa-game/game/common/emp/page`,
      name: "获取用户列表",
      post: function (params) {
        return http.post(this.url, params);
      }
    },
    getPmCustomer: {
      url: `${config.API_URL}/lqa-game/system/userCustomer/getMyCustomer`,
      name: "获取用户对应客户列表",
      get: function () {
        return http.get(this.url);
      }
    },
    getAllUserDict: {
      url: `${config.API_URL}/lqa-game/system/emp/allUserDict?projectNum=`,
      name: "获取所有用户字典列表",
      get: function (param1, param2) {
        return http.get(this.url + param1 + '&target=' + param2);
      }
    },
    getUserInfoList: {
      url: `${config.API_URL}/lqa-game/system/emp/alllist`,
      name: "获取语言包列表",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    getUserRoleValue: {
      get: function (id) {
        return http.get("/lqa-game/system/emp/roleMap", {empId: id});
      }
    },
    updateEmp: {
      url: `${config.API_URL}/lqa-game/system/emp`,
      name: "修改用户",
      put: function (data) {
        return http.put(this.url, data);
      }
    },
    addEmpUser: {
      url: `${config.API_URL}/lqa-game/system/emp`,
      name: "新增用户",
      post: function (data) {
        return http.post(this.url, data);
      }
    },
    resetPwd: {
      url: `${config.API_URL}/lqa-game/system/emp/resetUserPwd?userId=`,
      name: "重置密码",
      get: function (param) {
        return http.get(this.url + param);
      }
    },
    // 通过用户名 + 邮箱地址发起重置密码申请
    resetPwdMail: {
      put: async function (data) {
        try {
          const res = await http.get("/lqa-game/system/emp/send/reset/password/email", data);
          if (res && res.code === 200) {
            return true;
          }
        } catch (e) {
          // todo
        }
        return false;
      }
    },
    resetPassword: {
      name: "重置密码",
      post: async function (data) {
        try {
          const res = await http.get("/lqa-game/system/emp/reset/password", data);
          if (res && res.code === 200) {
            return true;
          }
        } catch (e) {
          // todo
        }
        return false;
      }
    },
    addCustomUser: {
      url: `${config.API_URL}/lqa-game/system/emp/custom`,
      name: "新增用户",
      post: function (data) {
        return http.post(this.url, data);
      }
    },
    updateCustomUser: {
      url: `${config.API_URL}/lqa-game/system/emp/custom`,
      name: "修改用户",
      put: function (data) {
        return http.put(this.url, data);
      }
    },
  },
  app: {
    list: {
      url: `${config.API_URL}/system/app/list`,
      name: "应用列表",
      get: function () {
        return http.get(this.url);
      }
    }
  },
  log: {
    list: {
      url: `${config.API_URL}/lqa-game/monitor/operlog/list`,
      name: "日志列表",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    listJob: {
      url: `${config.API_URL}/lqa-game/monitor/job/list`,
      name: "日志列表",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    updateJob: {
      url: `${config.API_URL}/lqa-game/monitor/job`,
      name: "日志列表",
      put: function (data) {
        return http.put(this.url, data);
      }
    },
    saveJob: {
      url: `${config.API_URL}/lqa-game/monitor/job`,
      name: "日志列表",
      post: function (data) {
        return http.post(this.url, data);
      }
    },
    deleteJob: {
      url: `${config.API_URL}/lqa-game/monitor/job/`,
      name: "删除基本客户信息",
      delete: function (id) {
        return http.delete(this.url + id);
      }
    },
    runJobNow: {
      url: `${config.API_URL}/lqa-game/monitor/job/run`,
      name: "删除基本客户信息",
      put: function (data) {
        return http.put(this.url, data);
      }
    },
    getJobLogger: {
      url: `${config.API_URL}/lqa-game/monitor/jobLog/list`,
      name: "日志列表",
      get: function (params) {
        return http.get(this.url, params);
      }
    }
  },
  table: {
    list: {
      url: `${config.API_URL}/system/table/list`,
      name: "表格列管理列表",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    info: {
      url: `${config.API_URL}/system/table/info`,
      name: "表格列管理详情",
      get: function (params) {
        return http.get(this.url, params);
      }
    }
  },
  tasks: {
    list: {
      url: `${config.API_URL}/system/tasks/list`,
      name: "系统任务管理",
      get: function (params) {
        return http.get(this.url, params);
      }
    }
  },
  home: {
    topCount: {
      url: `${config.API_URL}/lqa-game/system/homePage/topCount`,
      name: "获取首页头部待办数量",
      get: function () {
        return http.get(this.url);
      }
    },
    getTask: {
      url: `${config.API_URL}/lqa-game/system/homePage/getMyTask`,
      name: "获取任务列表",
      get: function (param) {
        return http.get(this.url, param);
      }
    },
    getNotice: {
      url: `${config.API_URL}/lqa-game/system/homePage/getNotice`,
      name: "获取公告列表",
      get: function () {
        return http.get(this.url);
      }
    },
    getProjectNames: {
      url: `${config.API_URL}/lqa-game/system/homePage/getMyProNames`,
      name: "获取我的所有项目名称",
      get: function () {
        return http.get(this.url);
      }
    },
    getTaskProcess: {
      url: `${config.API_URL}/lqa-game/system/homePage/getMyProTask?projectId=`,
      name: "获取我的项目任务报表",
      get: function (param) {
        return http.get(this.url + param);
      }
    },
    getAllBugType: {
      url: `${config.API_URL}/lqa-game/system/homePage/getBugTypeCount?projectId=`,
      name: "获取我的项目任务报表",
      get: function (param) {
        return http.get(this.url + param);
      }
    },

  },
  notice: {
    listNotice: {
      url: `${config.API_URL}/lqa-game/system/notice/list`,
      name: "获取客户信息",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    getNoticeInfo: {
      url: `${config.API_URL}/lqa-game/system/notice/`,
      name: "查询基本客户信息",
      get: function (params) {
        return http.get(this.url + params);
      }
    },
    addNoticeInfo: {
      url: `${config.API_URL}/lqa-game/system/notice`,
      name: "添加基本客户信息",
      post: function (data) {
        return http.post(this.url, data);
      }
    },
    updateNotice: {
      url: `${config.API_URL}/lqa-game/system/notice`,
      name: "修改基本客户信息",
      put: function (data) {
        return http.put(this.url, data);
      }
    },
    delNoticeInfo: {
      url: `${config.API_URL}/lqa-game/system/notice/`,
      name: "删除基本客户信息",
      delete: function (id) {
        return http.delete(this.url + id);
      }
    },
  },
  custom: {
    listCutomInfo: {
      url: `${config.API_URL}/lqa-game/system/userCustomer/list`,
      name: "获取客户信息",
      get: function (params) {
        return http.get(this.url, params);
      }
    },
    getCutomInfo: {
      url: `${config.API_URL}/lqa-game/system/userCustomer/`,
      name: "查询基本客户信息",
      get: function (params) {
        return http.get(this.url + params);
      }
    },
    addCutomInfo: {
      url: `${config.API_URL}/lqa-game/system/userCustomer`,
      name: "添加基本客户信息",
      post: function (data) {
        return http.post(this.url, data);
      }
    },
    updateCutomInfo: {
      url: `${config.API_URL}/lqa-game/system/userCustomer`,
      name: "修改基本客户信息",
      put: function (data) {
        return http.put(this.url, data);
      }
    },
    delCutomInfo: {
      url: `${config.API_URL}/lqa-game/system/userCustomer/`,
      name: "删除基本客户信息",
      delete: function (id) {
        return http.delete(this.url + id);
      }
    },
    exportLanguage: {
      url: `${config.API_URL}/lqa-game/system/userCustomer/export/data`,
      name: "导出任务信息",
      get: function (id) {
        return http.get(this.url + id);
      }
    },
    getAllPMInfo: {
      url: `${config.API_URL}/lqa-game/system/userCustomer/getPMInfo`,
      name: "获取任务信息",
      get: function () {
        return http.get(this.url);
      }
    },
    getCustomByUserId: {
      url: `${config.API_URL}/lqa-game/system/userCustomer/getcmbyuid`,
      name: "获取任务信息",
      post: function (data) {
        return http.post(this.url, data);
      }
    },
    getAllCustomers: {
      url: `${config.API_URL}/lqa-game/system/userCustomer/getCustomerInfos?userId=`,
      name: "获取任务信息",
      get: function (params) {
        return http.get(this.url + params);
      }
    },

  }
}
